<template>
    <div>
        <!-- 指派 -->
        <el-form ref="form" :model="form" label-width="80px" class="event-form">
            <el-row>
                <el-form-item label="下一节点" v-if="type!='转交'&&type!='发布失败'&&type!='观察完成'&&type!='拒绝'&&type!='取消'&&type!='驳回'">
                    <el-input v-model="this.form.handle" disabled></el-input>
                </el-form-item>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="处理组" v-if="type!='发布失败'&&type!='观察完成'&&type!='拒绝'&&type!='取消'&&type!='驳回'&&type!='CAB审批不通过'">
                        <el-select v-model="form.currentDepartment" filterable placeholder="请选择" @change="departmentChange">
                            <el-option v-for="item in departmentList" :key="item.index" :label="item.name"
                                       :value="item.id"></el-option>
                        </el-select>
                        <el-button :type="groupTasksTotal>=5?'danger':'success'" plain  >组繁忙度  ({{groupTasksTotal}})</el-button>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="处理人" v-if="type!='发布失败'&&type!='观察完成'&&type!='拒绝'&&type!='取消'&&type!='驳回'&&type!='CAB审批不通过'">
                        <div class="el-form__inline">
                            <el-input v-model="form.currentHandlerName" disabled></el-input>
                            <el-button  type="primary" class="iconfont icon-gengduo icon" :disabled="dis_user" @click="toRequesterList"></el-button>
                            <el-button type="primary" :type="userTasksTotal>=5?'danger':'success'" plain >人员繁忙度  ({{userTasksTotal}})</el-button>
                        </div>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="解决标识" v-if="type=='制定发布方案'">
                        <el-select v-model="form.solutionLabel" placeholder="请选择" >
                            <el-option v-for="item in solutionLabel" :key="item.id" :label="item.cname"
                                       :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <!--高危操作-->
                <el-col :span="12" v-if="type=='制定发布方案'">
                    <el-form-item label="高危操作" prop="isHighRiskOperation">
                        <el-radio v-model="form.isHighRiskOperation" label="1">是</el-radio>
                        <el-radio v-model="form.isHighRiskOperation" label="0">否</el-radio>
                    </el-form-item>
                </el-col>
            </el-row>
            <!--完成程度-->
            <el-form-item prop="completionDegree" label="完成程度" v-if="type=='发布'">
                <el-select v-model="form.completionDegree" placeholder="请选择">
                    <el-option v-for="item in completionDegree" :key="item.id" :label="item.cname"
                               :value="item.id"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="处理意见" v-if="type!='制定发布方案'">
                <el-input type="textarea" v-model="form.handleComment"></el-input>
            </el-form-item>
            <el-row>
                <el-col :span="24">
                    <el-form-item label="发布方案" v-if="type=='制定发布方案'">
                       <ueditor v-model="form.solutionComment" :config="myConfig" :key="1" :value="2" @ready="editorReady"></ueditor>
                        <div>
                            <el-checkbox v-model="upKnowledge">解决方案保存到知识库</el-checkbox>
                        </div>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row v-if="upKnowledge">
                <el-col :span="12" v-if="type=='制定发布方案'">
                    <el-form-item label="知识分类">
                        <el-select v-model="knowledgeClass" placeholder="请选择">
                            <el-option v-for="item in categoryList" :key="item.id" :label="item.title"
                                       :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12" v-if="type=='制定发布方案'">
                    <el-form-item label="知识关键字">
                        <el-input v-model="knowledgeKeyword"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-form-item label="知会" >
                <div class="el-form__inline">
                    <notifyTab :data="form.notify" :getData="getNotifyData"></notifyTab>
                    <router-link :to="{ path:'/requesterList',query: { callback:getNoticer,moreSelect:true } }">
                        <span  class="noticeAdd">+</span>
                    </router-link>
                </div>
            </el-form-item>
            <el-form-item label="附件" v-if="type=='制定发布方案'">
                <inputFile :data="attachment" :getFiles="getFiles"></inputFile>
            </el-form-item>


            <el-form-item>
                <el-button type="primary" @click="submit" :disabled="isSubmit">确定</el-button>
                <el-button type="default" @click="onCancel">取消</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    import notifyTab from "../common/notifyTab.vue"
    const VueUeditorWrap = window.VueUeditorWrap;
    import Config from "../../app.config";
    import ueditor from "../../components/ueditor.vue"
    import services from "../deploy/deploy.service";
    import commonService from "../../services/common.service"
    import inputFile from "../common/inputFile.vue"
    export default {
        props:{
            serialNumber:String,
            callback:Function,
            type:{
                type:String,
                default:""
            },
            deployType:String,
            status:String,
            currentHandler:String,  //当前处理人，用于cab审批通过时选择处理人时排除自己
        },
        components:{ ueditor,notifyTab,inputFile },
        data() {
            return {
                form:{
                    currentDepartment:"",
                    designator:'',
                    handle:"",
                    currentHandlerName:'',
                    currentHandlerId:'',
                    handleComment:'',
                    solution:'',
                    solutionLabel:"",
                    attachment:'',
                    notify:[],
                    isHighRiskOperation: "0",  //高危操作
                },
                notifyUserid:[],
                solutionComment:'',
                upKnowledge:false,
                knowledgeClass:"",
                knowledgeKeyword:"",
                departmentList:[],      // 处理组
                dis_user:true,
                attachment:[],        //上传附件
                categoryList:[],
                groupTasksTotal:'',
                userTasksTotal:'',
                isSubmit:false,
                noDepartment:false,  //控制点击‘发布完成’ 和‘发布失败’时可不选处理组直接提交
                exceptMe:false,   //在CAB审批通过时不能选择自己(当前处理人)
                myConfig: {
                    autoHeightEnabled: false,
                    initialFrameHeight: 200,
                    initialFrameWidth: '100%',
                    UEDITOR_HOME_URL: '/UEditor/',
                    serverUrl:Config.BASE_API + "upload/",
                },
            }
        },
        created() {
            this.getDepartment();
            this.getUserId()
            this.getCategoryList();
            this.$modal.title=this.type

            if(this.type == "发布工单接收"){
                this.form.handle = "CBA审批/制定发布方案"

            };

            if(this.type == "全部通过"){
                this.$modal.title='CAB全部通过'
                this.form.handle = "制定发布方案"
            };
            if(this.type == "制定发布方案"){
                this.form.handle = "UAT环境实施发布"
                this.getDetail()
            };
            if(this.type == "实施通过"){
                this.$modal.title='UAT实施通过'
                this.form.handle = "生产环境实施发布"
            };
            if(this.type == "实施不通过"){
                this.$modal.title='UAT实施不通过'
                this.form.handle = "制定发布方案"
            };
            if(this.type == "CAB审批通过"){
                this.form.handle = "CAB评审"
                this.exceptMe=true
            };
            if(this.type == "CAB审批不通过"){
                this.form.handle = "服务台"
            };
            if(this.type == "发布"){
                this.$modal.title='发布完成'
                this.form.handle = "观察中"
            };
            if (this.type=='CAB评审') {
                this.form.handle='CAB评审请求'
            };

            if (this.type=='审核不通过') {
                this.form.handle='提交审核'
            };
            if (this.type=='发布完成') {
                this.form.handle='观察中'
            }
            if(this.type=='观察完成'){
                this.form.handle='发布完成'
            }
            if (this.type=='拒绝'){
                this.form.handle='拒绝'
            }
            if (this.type=='取消'){
                this.form.handle='取消'
            }

        },
        computed:{
            dictionary(){
                return this.$store.state.dictionary;
            },
            // 知识分类id
            knowledgeType(){
                return this.$store.state.caseType.knowledge;
            },
            //解决标识
            solutionLabel(){
                return this.dictionary.solution_label;
            },
            completionDegree(){
                return this.dictionary.completion_degree
            }
        },
        methods: {
            //制定发布方案时要请求一次数据。将已有数据填上去
            getDetail(){
                services.detail({serialNumber:this.serialNumber}).then(res => {
                    this.form.solutionLabel=res.solutionLabel
                    this.form.solutionComment=res.solutionComment
                }).catch(err => {
                    this.$message.error(err.message);
                }).finally(()=>{
                    this.loading=false
                })
            },
            getUserId(){
                this.form.designator=localStorage.getItem('internalUserid')
            },
            // 获取知识分类
            getCategoryList(){
                commonService.categoryList(this.knowledgeType.id).then(res => {
                    this.categoryList = res;
                })
            },
            // 编辑器获取内容
            editorReady (editorInstance) {
                editorInstance.setContent('你可以在这里初始化编辑器的初始内容。');
                let _this = this
                editorInstance.addListener('contentChange', () => {
                   _this.form.solutionComment = editorInstance.getContent()
                });
            },
            // 服务组
            getDepartment(){
                let params= {
                    departmentId:this.type == "CAB审批通过"&&this.deployType!='81'?99998:99999,
                    type:'group'
                }
                if (this.deployType!='81'&&this.type == "发布工单接收"){
                    params.departmentId=99998
                }
                if (this.type=='转交'&&this.status=='CAB审批') {
                    params.departmentId=99998
                }
                commonService.getDepartmentList(params).then(res => {
                    this.departmentList = res.list;
                })
            },
            departmentChange(){
                this.dis_user = this.form.currentDepartment ? false : true;
                let groupId=this.form.currentDepartment
                this.form.currentHandlerName=''
                this.userTasksTotal=''
                this.getGroupBusyness(groupId)
            },
            getGroupBusyness(id){
                commonService.busynessGroup(id).then(res => {
                    this.groupTasksTotal = res.tasksTotal;
                }).catch(err => {
                    this.$message.error(err.message);
                }).finally(() => {
                    this.loading = false;
                })
            },
            submit(){
                this.isSubmit=true
                let params=this.getParams()
                if (this.type=='发布失败'||this.type=='观察完成'||this.type=='拒绝'||this.type=='取消'||this.type=='驳回'||this.type=='CAB审批不通过'){
                    this.noDepartment=true
                }
                if (!this.noDepartment&&!params.currentDepartment){
                    this.isSubmit=false
                    this.$message.error('请选择处理组')
                } else if (this.type == '发布' && !this.form.completionDegree){
                    this.isSubmit = false
                    this.$message.error('请选择完成程度')
                } else if(this.type!='发布失败'&&this.type!='观察完成'&&this.type!='拒绝'&&this.type!='取消'&&this.type!='驳回'&&this.type!='CAB审批不通过'&&!this.form.currentHandlerName){
                    this.isSubmit=false
                    this.$message.error('请选择处理人')
                }else if(this.type!='制定发布方案'&&!this.form.handleComment){
                    this.isSubmit=false
                    this.$message.error('请填写处理意见')
                }else if(this.type=='制定发布方案'&&!this.form.solutionLabel){
                    this.isSubmit=false
                    this.$message.error('请选择解决标识')
                }else if(this.type=='制定发布方案'&&!this.form.solutionComment){
                    this.isSubmit=false
                    this.$message.error('请填写发布方案')
                }else{
                    commonService.deployHandle(params).then(res => {
                        this.$message.success(this.$modal.title + "成功");
                        this.close(true);
                    }).catch(err => {
                        this.isSubmit = false
                        this.$message.error(err.message);
                    })
                }


            },
            getParams(){
                this.notifyUserid=this.form.notify&&this.form.notify.map(item=>{return item.userid})
                let upKnowledge = this.upKnowledge ? "1" : "0";
                let params = {
                    ...this.form,
                    handle:this.type,
                    designator:this.form.designator,
                    serialNumber:this.serialNumber,
                    handleComment:this.form.handleComment,
                    currentHandler:this.form.currentHandlerId,
                    solution:this.solutionComment,
                    upKnowledge:upKnowledge,
                    attachment:this.attachment,
                    notify:this.notifyUserid

                };
                if(this.upKnowledge){
                    params.knowledgeKeyword = this.knowledgeKeyword.split(",");
                    params.knowledgeClass = this.knowledgeClass;
                }
                return params;
            },
            //将选择的知会人信息去重保存
            getNoticer(obj){
                this.form.notify=this.arrayUnique(this.form.notify.concat(obj))
            },
            //删除后显示剩余的知会人
            getNotifyData(val){
                this.form.notify=val
            },
            //选择完知会人后去重，此方法可通用于包含对象的数组深层次去重
            arrayUnique(arr){
                let obj={}
                let newArr = []
                arr.forEach(item=>{
                    if(!obj[item.id]){
                        obj[item.id]=1
                        newArr.push(item)
                    }
                })
                return newArr

            },
            // 组员页面
            toRequesterList(){
                let id = this.form.currentDepartment;
                this.$router.push({
                    path: '/appointUser',
                    name: "appointUser",
                    query: {
                        callback:this.getRequester,
                        id:`${id}`,
                        currentHandler:this.currentHandler,
                        exceptMe:this.exceptMe
                    }
                })
            },
            getRequester(obj){
                this.form.currentHandlerName = obj.name;
                this.form.currentHandlerId = obj.internalUserid;
                let userid=this.form.currentHandlerId
                this.getUserBusyness(userid)
            },
            getUserBusyness(id){
                commonService.busynessUser(id).then(res => {
                    this.userTasksTotal= res.tasksTotal;
                }).catch(err => {
                    this.$message.error(err.message);
                }).finally(() => {
                    this.loading = false;
                })
            },
            //上传附件
            getFiles(val){
                this.attachment = val;
            },
            onCancel(){
                this.close();
            },
            close(refresh) {
                this.$modal.close();
                refresh && refresh === true ? this.callback() : '';
            }

        }
    }
</script>

<style lang="scss" scoped rel="stylesheet/scss">
    .noticeAdd{
        color: #1890ff;
        font-size: 27px;
        position: relative;
        top: -2px;
        margin-left: 10px;
    }
</style>
